import React, { useState, useEffect } from 'react';
import ReactMarkdown from "react-markdown";


const OpinionText = ({ setStateContentLinks, opinion }) => {
    const [didMount, setDidMount] = useState(false)

    useEffect(() => {
        if (didMount) {
            var htmlCollection = document.getElementsByClassName('linkable-section');
            setStateContentLinks([
                { id: "opinion-intro", textContent: "Introducción" },
                { id: "opinion-proscons", textContent: "Pros y Cons" },
                ...htmlCollection
            ]);
        } else setDidMount(true)
    },[didMount]);

    return <ReactMarkdown source={opinion} escapeHtml={false} />
};

export default OpinionText;